import { atom, selector } from 'recoil'
import {
  toastDismiss,
  toastShow,
  TOAST_VARIANT_INFO,
  TOAST_VARIANT_SUCCESS,
  TOAST_VARIANT_WARNING,
  TOAST_VARIANT_ERROR
} from 'mailup-web-components'

const APP_TOAST_KEY = 'app-toast'

const APP_TOAST_VARIANTS = [
  TOAST_VARIANT_SUCCESS,
  TOAST_VARIANT_INFO,
  TOAST_VARIANT_WARNING,
  TOAST_VARIANT_ERROR
]

const toastDataState = atom({
  key: 'toastDataState',
  default: {
    message: undefined,
    severity: undefined,
    visible: undefined,
    key: APP_TOAST_KEY
  }
})

export const toastState = selector({
  key: 'toastState',
  get: ({ get }) => !!get(toastDataState),
  set: ({ set, reset }, options) => {
    if (!options) {
      toastDismiss(toastDataState.key)
      reset(toastDataState)
      return
    }

    const { message, severity } = options

    set(toastDataState, {
      message,
      severity,
      visible: true
    })

    toastShow(
      options.message,
      APP_TOAST_VARIANTS[options.severity] || APP_TOAST_VARIANTS[0],
      APP_TOAST_KEY
    )
  }
})
